import { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { isBlank, cleanString } from "utils/helpers"
import SearchInput from "components/ui/SearchInput"

export const SEARCH_KIND = "nameOrEmail"

const FilterInput = ({ onSubmit, onRemove, selected }) => {
  const [value, setValue] = useState("")
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setValue(selected.value || "")
  }, [selected])

  const handleChange = event => setValue(event.target.value)

  const handleKeyDown = event => {
    if (event.keyCode === 13) {
      if (isBlank(value)) {
        return onRemove(SEARCH_KIND)
      }

      if (!loading) {
        setLoading(true)

        return onSubmit({
          value: cleanString(value, /[";&]+/g),
          kind: SEARCH_KIND,
          key: SEARCH_KIND
        }).finally(() => setLoading(false))
      }
    }
  }

  return (
    <SearchInput
      placeholder="Search by name or email"
      value={value}
      onKeyDown={handleKeyDown}
      onChange={handleChange}
      onClear={() => onRemove(SEARCH_KIND)}
    />
  )
}

FilterInput.propTypes = {
  onSubmit: PropTypes.func,
  onRemove: PropTypes.func,
  selected: PropTypes.shape({
    value: PropTypes.string
  })
}

export default FilterInput
